module.exports = __webpack_public_path__ + "static/media/SR BIPC(20-06-2026).9d21a938.xlsx";